export enum HELP_BLOG_ROUTES {
	CATEGORIES = 'categories',
	AUTHORS = 'authors',
	CATEGORY = 'categories/:slug',
	AUTHOR = 'authors/:slug',
	ARTICLE = ':slug',
	preview = '/preview/help',
}
